<template>
    <v-ons-page>
        <div class="page-header">
            <img src="../assets/hynds-vip.svg" width="140px">
        </div>

        <div v-show="loading" class="text-center page-progress-loader">
            <v-ons-progress-circular
                indeterminate
                ></v-ons-progress-circular>
        </div>

        <h2>Account Details</h2>
        <v-ons-list v-show="!loading" modifier="noborder" class="form">
            <template v-if="registered">
            </template>
            <template v-else>
                <v-ons-list-item modifier="nodivider">
                    <label :class="[error.trading_name ? 'invalid' : '']"
                        for="trading_name">Company name</label>
                    <v-ons-input
                        placeholder=""
                        input-id="trading_name"
                        v-model="profile.trading_name">
                    </v-ons-input>
                    <small v-show="error.trading_name" class="invalid">{{ _.first(error.trading_name) }}</small>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider" class="form-group">
                    <label for="customer_code" :class="[error.customer_code ? 'invalid' : '']">
                        Customer code
                    </label>
                    <v-ons-input
                        placeholder=""
                        input-id="customer_code"
                        v-model="profile.customer_code">
                    </v-ons-input>
                    <small v-show="error.customer_code" class="invalid">{{ _.first(error.customer_code) }}</small>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider">
                    <label for="firstname" :class="[error.firstname ? 'invalid' : '']">
                        First name
                    </label>
                    <v-ons-input
                        placeholder=""
                        input-id="firstname"
                        v-model="profile.firstname">
                    </v-ons-input>
                    <small v-show="error.firstname" class="invalid">{{ _.first(error.firstname) }}</small>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider">
                    <label for="lastname" :class="[error.lastname ? 'invalid' : '']">
                        Last name
                    </label>
                    <v-ons-input
                        placeholder=""
                        input-id="lastname"
                        v-model="profile.lastname">
                    </v-ons-input>
                    <small v-show="error.lastname" class="invalid">{{ _.first(error.lastname) }}</small>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider" class="form-group">
                    <label for="email" :class="[error.email ? 'invalid' : '']">
                        Email
                    </label>
                    <v-ons-input
                        type="email"
                        placeholder=""
                        input-id="email"
                        v-model="profile.email">
                    </v-ons-input>
                    <small v-show="error.email" class="invalid">{{ _.first(error.email) }}</small>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider">
                    <label for="password" :class="[error.password ? 'invalid' : '']">
                        Password
                    </label>
                    <v-ons-input
                        placeholder=""
                        input-id="password"
                        type="password"
                        v-model="profile.password">
                    </v-ons-input>
                    <small v-show="error.password" class="invalid">{{ _.first(error.password) }}</small>
                </v-ons-list-item>
                <v-ons-list-item modifier="nodivider">
                    <label for="confirm_password" :class="[error.confirm_password ? 'invalid' : '']">
                        Confirm Password
                    </label>
                    <v-ons-input
                        placeholder=""
                        input-id="confirm_password"
                        type="password"
                        v-model="profile.confirm_password">
                    </v-ons-input>
                    <small v-show="error.confirm_password" class="invalid">{{ _.first(error.confirm_password) }}</small>
                    <p class="form-text">Min 8 characters, one UPPERCASE letter and one number.</p>
                </v-ons-list-item>
            </template>

            <v-ons-list-item modifier="nodivider" class="form-buttons">
                <v-ons-button v-if="!registered" @click="save"
                    class="button button--primary">
                    Register
                </v-ons-button>
                 <v-ons-button
                    @click="$router.push({ name: 'login' })"
                    modifier="cta"
                    class="mb-20">
                    Return to login
                </v-ons-button>
            </v-ons-list-item>
        </v-ons-list>
    </v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import PushNotification from './mixins/PushNotification'
import Module from './mixins/Module'

export default {
    data() {
        return {
            loading: false,
            approved: false,
            registered: false,

            profile: {
                trading_name: '',
                customer_code: '',

                firstname: '',
                lastname: '',
                email: '',

                password: '',
                confirm_password: '',
            },

            error: {
                trading_name: null,
                customer_code: null,

                firstname: null,
                lastname: null,
                email: null,

                password: null,
                confirm_password: null,
            },
        }
    },

    created() {
        this.$emit('init', {
            name: 'register',
            title: 'Register',
            showMenu: false,
        })
    },

    mixins: [
        Utils,
        PushNotification,
        Module('login'),
        Module('customer'),
    ],

    methods: {
        save() {
            this.loading = true
            this.api.postData('/my/profile', {}, this.profile)
                .then(res => {
                    this.registered = false;
                    this.approved = _.get(res, 'attributes.approved', false);
                    this.error = {};

                    if (this.approved) {
                        this.signin(res)
                        // this.alert({
                            // title: '',
                            // message: `Your account has been approved`,
                            // buttonLabels: 'Home',
                            // callback: () => this.$router.push({ name: 'home' })
                        // })
                        this.registerDevice(this.customer.content.id);
                        this.applyTheme(res);

                        return this.$router.push({ name: 'home' });
                    } else {
                        this.alert({
                            title: 'Registration Pending',
                            messageHTML: `<p>Thanks for registering for access to the Hynds VIP app.<br><br>
                            Unfortunately we were not able to automatically approve your login. Your registration request has been sent to our team for processing.
                            You will receive an email advising you when your login has been activated.<br>
                            Please contact us if you have any questions.</p>`,
                            buttonLabels: 'Return to Login',
                            callback: () => this.$router.push({ name: 'login' })
                        })
                    }
                })
                .catch(err => {
                    this.alert({
                        title: 'Oops!',
                        messageHTML: `<p>There was an error in submitting your registration.<br><br>Please check your details are correct and try again.</p>`,
                        buttonLabels: 'OK',
                    })
                    this.error = _.get(err, 'response.data.errors', this.error);
                })
                .finally(() => {
                    this.loading = false
                })
        },

        signin(login) {
            this.login.setContent(login)
            this.customer.setContent(_.get(login, 'included.parent', {}))
            window.localStorage.setItem('login', JSON.stringify(login))
            this.setToken(login.token)
        },

        applyTheme(login) {
            const customer = _.get(login, 'included.parent', {});
            const customerType = _.get(customer, 'attributes.customer_type', 'Gold');
            document.body.classList.add(`theme-${customerType.toLowerCase()}`)
        },
    }
};
</script>

<style scoped>
/* .right-icon {
  margin-left: 10px;
}
.right-label {
  color: #666;
} */
ons-input {
    width: 100%;
}
.float-right {
    float: right;
}
.list-item{
    padding: 0 14px;
}
.page-header {
    text-align: center;
    padding: 5rem 0 1rem 0 !important;
}
.form-text{
    margin-bottom: 0;
}
img {
    max-width: 300px;
}
.invalid {
    color: #ef3800;
}
.form-buttons{
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/RegisterPage.vue